import React from "react";
import Viewer from "../viewer";

interface Props {
  src: string;
  hideDownloadButton?: boolean;
}

const SampleViewer: React.FunctionComponent<Props> = ({
  src,
  hideDownloadButton = true
}) => {
  return <Viewer src={src} visibleSaveButton={!hideDownloadButton} />;
};

export default SampleViewer;
